export const ICONS_CHANGE_STATE = 'ICONS_CHANGE_STATE';

export default function setIconsChange(payload) {
  return {
    type: ICONS_CHANGE_STATE,
    payload,
  };
}
